import BaseClipSelectPage from './components/BaseClipSelectPage';
import {
  OnOpenInAdvancedEditor,
  OnReprocessClip,
  OnSubmit,
} from './containers/ClipSelectContext';
import ClipSelectPage, {
  ClipSelectPageProps,
} from './containers/ClipSelectPage';
import { ClipSuggestion } from './types';

export default ClipSelectPage;
export {
  BaseClipSelectPage,
  ClipSelectPageProps,
  ClipSuggestion,
  OnOpenInAdvancedEditor,
  OnReprocessClip,
  OnSubmit,
};
